import { DEFAULT_ATTRIBUTES, UID } from 'shared/api/query/constants';
import { aiChat as aiChatConfig, aiChatMessage as aiChatMessageConfig } from 'shared/api/query/configs.json';

export const children = [
  ...DEFAULT_ATTRIBUTES,
  {
    attr: aiChatMessageConfig.edges.chat,
    model: aiChatConfig.model,
    children: [{ attr: UID }],
  },
  { attr: aiChatMessageConfig.edges.role },
  { attr: aiChatMessageConfig.edges.content, default: '' },
];
